import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import Checkbox from '@/components/ui/Checkbox/Checkbox';
import RegulationsContent, { RegulationsIntro } from '@/components/Regulations/RegulationsContent';
import OpenFundSection from '../components/OpenFundSection';
import SignaturePadField from '../components/SignaturePadField';
import { useOpenFundFieldTracking } from '../OpenFundAnalyticsContext';
import { OpenFundFormData } from '../schemas/openFundFormSchema';
import styles from './steps.module.scss';

const TermsAndSignatureStep = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<OpenFundFormData>();
  const trackField = useOpenFundFieldTracking();

  return (
    <div className={styles.stepWrapper}>
      <OpenFundSection title="מידע נוסף ותנאי שימוש">
        {/* The regulations themselves live in components/Regulations (HAT-1256): the portal's
            entry gate asks every coordinator to confirm the same text, and a second copy of it
            would be a second thing to keep current. */}
        <RegulationsIntro />

        <RegulationsContent />

        <div className={styles.agreementsGroup}>
          <Controller
            control={control}
            name="personalInterfaceInNedarimPlus"
            render={({ field }) => (
              <label className={styles.agreementPill}>
                <Checkbox
                  checked={!!field.value}
                  onCheckedChange={(v) => {
                    field.onChange(v);
                    trackField('personalInterfaceInNedarimPlus');
                  }}
                />
                <span>
                  {t('openFundRequest.fields.personalInterfaceInNedarimPlus')}
                </span>
              </label>
            )}
          />
          <Controller
            control={control}
            name="termsAndConditionsAccepted"
            render={({ field, fieldState }) => (
              <div>
                <label className={styles.agreementPill}>
                  <Checkbox
                    checked={!!field.value}
                    onCheckedChange={(v) => {
                      field.onChange(v);
                      trackField('termsAndConditionsAccepted');
                    }}
                  />
                  <span>
                    {t('openFundRequest.fields.termsAccepted')}
                  </span>
                </label>
                {fieldState.error && (
                  <span className="body-sm-regular text-(--font-error)">
                    {fieldState.error.message as string}
                  </span>
                )}
              </div>
            )}
          />

          <Controller
            control={control}
            name="regulationsAccepted"
            render={({ field, fieldState }) => (
              <div>
                <label className={styles.agreementPill}>
                  <Checkbox
                    checked={!!field.value}
                    onCheckedChange={(v) => {
                      field.onChange(v);
                      trackField('regulationsAccepted');
                    }}
                  />
                  <span>
                    {t('openFundRequest.fields.regulationsAccepted')}
                  </span>
                </label>
                {fieldState.error && (
                  <span className="body-sm-regular text-(--font-error)">
                    {fieldState.error.message as string}
                  </span>
                )}
              </div>
            )}
          />
        </div>

        <SignaturePadField<OpenFundFormData>
          name="signature"
          label={t('openFundRequest.fields.signature')}
        />
      </OpenFundSection>
    </div>
  );
};

export default TermsAndSignatureStep;
